// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"xN-z","carouselContainer":"yN-z"};